import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { UserActionName } from '@frontend/user/types';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React from 'react';

import useUserActionSelect from './user-action-select.controller';

const ID = 'user-action-select';

export interface UserActionSelectProps extends Omit<SelectInputV2Props<UserActionName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const UserActionSelect = (props: UserActionSelectProps) => {
    const viewProps = useUserActionSelect(props);

    return (
        <SelectInputV2<UserActionName>
            {...props}
            id={ID + props.id}
            label={props.label || 'User action'}
            options={viewProps.options}
        />
    );
};

export default UserActionSelect;
